import React, { useContext, useEffect, useState } from "react";
import ModalAdicion from "./ModalAdicion/ModalAdicion";
import DomiciliosItem from "./DomiciliosItem";
import "./OtrosDomicilios.css";

const OtrosDomicilios = ({ acreditadoInfo }) => {
  const [showModal, setShowModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [currentDirList, setCurrentDirList] = useState([]);
  useEffect(() => {
    const listDir = [];
    listDir.push({
      Tipo: 1,
      NombreRef: acreditadoInfo.NombreRef1,
      DireccRef: acreditadoInfo.DireccRef1,
      ColoniaRef: acreditadoInfo.ColoniaRef1,
      LocaliRef: acreditadoInfo.LocaliRef1,
      TelRef: acreditadoInfo.TelRef1,
      CpRef: acreditadoInfo.CpRef1,
      AcreditadoId: acreditadoInfo.AcreditadoId,
    });

    listDir.push({
      Tipo: 2,
      NombreRef: acreditadoInfo.NombreRef2,
      DireccRef: acreditadoInfo.DireccRef2,
      ColoniaRef: acreditadoInfo.ColoniaRef2,
      LocaliRef: acreditadoInfo.LocaliRef2,
      TelRef: acreditadoInfo.TelRef2,
      CpRef: acreditadoInfo.CpRef2,
      AcreditadoId: acreditadoInfo.AcreditadoId,
    });
    setCurrentDirList(listDir);
  }, []);
  function editModal(item){
    setCurrentRow(item);
    setShowModal(true);
  }
  debugger
  return (
    <div className="Domicilios__container">
      <div className="Domicilios__btncontainer">
        <h1>Referencias Familiares</h1>
      </div>
      <div className="DomiciliosItems__container">
        {currentDirList.map((item) =>
          item.Domicilio !== "" ? (
            <DomiciliosItem currentRow={item} setCurrentRow={editModal} />
          ) : (
            <div className="btnAgregarDomicilio__container">
              <button className="btnAgregarDomicilio" onClick={()=>{setShowModal(true);setCurrentRow(item)}}>
                Agregar otro domicilio de {item.Tipo === 1 ? "Acreditado" : "Aval"}
              </button>
            </div>
          )
        )}
      </div>
      
      <ModalAdicion
        setShow={setShowModal}
        show={showModal}
        setCurrentRow={editModal}
        currentRow={currentRow}
        acreditadoInfo={acreditadoInfo}
      />
    </div>
  );
};

export default OtrosDomicilios;
